import _defineProperty from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { SPACINGS } from "../consts";

var getDesktopSpacing = function getDesktopSpacing() {
  var _ref;

  return _ref = {}, _defineProperty(_ref, SPACINGS.EXTRATIGHT, "2px"), _defineProperty(_ref, SPACINGS.TIGHT, "4px"), _defineProperty(_ref, SPACINGS.CONDENSED, "8px"), _defineProperty(_ref, SPACINGS.COMPACT, "12px"), _defineProperty(_ref, SPACINGS.NATURAL, "16px"), _defineProperty(_ref, SPACINGS.COMFY, "24px"), _defineProperty(_ref, SPACINGS.LOOSE, "32px"), _defineProperty(_ref, SPACINGS.EXTRALOOSE, "40px"), _ref;
};

export default getDesktopSpacing;